import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import AddressField from '../EditAddress/AddressField/AddressField';
import { Button } from '@unite-us/ui';
import _, { isEmpty, first } from 'lodash';
import OverlaySpinner from '../../../common/spinners/OverlaySpinner';
import { FACESHEET } from '../../../../constants/eventConstants';
import isAddressValid from '../../../utils/isAddressValid';
import newAddressFromFields from './utils/newAddressFromFields';
import './stylesheets/editAddress.scss';
import callOrLog from '../../../../constants/callOrLog';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';
import { trackEvent } from '../../../../config/api';
import { googleMapsKey } from '../../../../config/services';
import { google as googleUtils } from '@unite-us/client-utils';
var useGoogleMapsApi = googleUtils.useGoogleMapsApi;
export function EditAddressFields(props) {
  var addressesRef = useRef();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    addressesValidation = _useState2[0],
    setAddressesValidation = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    formErrors = _useState4[0],
    setFormErrors = _useState4[1];
  var onCancel = function onCancel() {
    props.closeModal();
  };
  var onSubmit = function onSubmit(values) {
    var _context;
    var addresses = _mapInstanceProperty(_context = values.addresses || []).call(_context, function (a) {
      return newAddressFromFields(a);
    });
    var response = _mapInstanceProperty(addresses).call(addresses, function (a) {
      return isAddressValid(a);
    });
    setAddressesValidation(response);
    var hasInvalidAddress = response.some(function (a) {
      return !a;
    });
    if (hasInvalidAddress) return;
    return props.updateOrCreateAddress(addresses).then(function () {
      callOrLog(function () {
        return trackEvent(FACESHEET.addressUpdated);
      });
      props.closeModal();
    });
  };
  var addField = function addField() {
    addressesRef.current.push({});
  };
  var removeOrDelete = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(fields, meta, index) {
      var address, newAddressesValidation;
      return _regeneratorRuntime.wrap(function _callee$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            address = fields.value[index];
            if (address.id) {
              props.deleteAddress(address.id);
            }
            fields.remove(index);
            if (!isEmpty(addressesValidation)) {
              newAddressesValidation = _toConsumableArray(addressesValidation);
              _spliceInstanceProperty(newAddressesValidation).call(newAddressesValidation, index, 1);
              setAddressesValidation(newAddressesValidation);
            }
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee);
    }));
    return function removeOrDelete(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
  var _clearValidation = function clearValidation(index) {
    if (!isEmpty(addressesValidation)) {
      var newAddressesValidation = _toConsumableArray(addressesValidation);
      newAddressesValidation[index] = true;
      setAddressesValidation(newAddressesValidation);
    }
  };
  var addressTypes = props.addressTypes,
    addresses = props.addresses,
    styles = props.styles,
    submitting = props.submitting;
  var _useGoogleMapsApi = useGoogleMapsApi({
      key: googleMapsKey
    }),
    google = _useGoogleMapsApi.google,
    isMapsLoaded = _useGoogleMapsApi.isMapsLoaded;
  if (!isMapsLoaded) {
    return /*#__PURE__*/React.createElement("p", null, "Loading...");
  }
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    mutators: _objectSpread({}, arrayMutators),
    initialValues: {
      addresses: addresses
    },
    render: function render(_ref2) {
      var handleSubmit = _ref2.handleSubmit;
      return /*#__PURE__*/React.createElement("form", {
        className: "edit-address content-with-actions",
        onSubmit: handleSubmit
      }, /*#__PURE__*/React.createElement(OverlaySpinner, {
        text: "Saving Addresses...",
        show: submitting
      }), /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, /*#__PURE__*/React.createElement(FieldArray, {
        name: "addresses"
      }, function (_ref3) {
        var fields = _ref3.fields,
          meta = _ref3.meta;
        addressesRef.current = fields;
        return _mapInstanceProperty(fields).call(fields, function (fieldName, index) {
          var _context3;
          return /*#__PURE__*/React.createElement("div", {
            id: "address-".concat(index),
            key: index,
            style: styles.inlineAddressContainer
          }, /*#__PURE__*/React.createElement(AddressField, {
            id: _concatInstanceProperty(_context3 = "".concat(fieldName, "-")).call(_context3, index),
            fieldName: fieldName,
            index: index,
            inline: false,
            remove: function remove() {
              return removeOrDelete(fields, meta, index);
            },
            addressTypes: addressTypes,
            isValidAddress: addressesValidation[index],
            clearValidation: function clearValidation() {
              return _clearValidation(index);
            },
            setFormErrors: setFormErrors,
            google: google
          }));
        });
      })), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-left col-sm-6 edit-address__add-address"
      }, /*#__PURE__*/React.createElement("button", {
        className: "text-sm",
        id: "add-address-link",
        type: "button",
        onClick: addField
      }, "+ Add Address")), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-6"
      }, /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-address-cancel-btn",
        onClick: onCancel,
        disabled: submitting,
        label: "Cancel"
      })), /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-address-save-btn",
        disabled: submitting,
        label: "Save",
        primary: true,
        onClick: function onClick() {
          if (!isEmpty(formErrors)) {
            setTimeout(function () {
              var focusableErrInput, focusableErrSelectField;
              var err = first(document.getElementsByClassName('ui-form-field--has-error'));
              if (err) {
                focusableErrInput = first(err === null || err === void 0 ? void 0 : err.getElementsByTagName('input'));
                focusableErrSelectField = first(err === null || err === void 0 ? void 0 : err.getElementsByClassName('choices'));
              }
              if (focusableErrInput && focusableErrSelectField === undefined) {
                var _focusableErrInput;
                focusableErrInput.ariaLabel = formErrors;
                (_focusableErrInput = focusableErrInput) === null || _focusableErrInput === void 0 || _focusableErrInput.focus();
              } else if (focusableErrSelectField) {
                var _focusableErrSelectFi;
                focusableErrSelectField.ariaLabel = formErrors;
                (_focusableErrSelectFi = focusableErrSelectField) === null || _focusableErrSelectFi === void 0 || _focusableErrSelectFi.focus();
              }
              setFormErrors({});
            }, 300);
          } else if (first(document.getElementsByClassName('ui-form-field--has-error'))) {
            var editAddressModal = document.getElementById('edit-address-modal');
            var errInModal = first(editAddressModal === null || editAddressModal === void 0 ? void 0 : editAddressModal.getElementsByClassName('ui-form-field--has-error'));
            var focusableErrInput = first(errInModal === null || errInModal === void 0 ? void 0 : errInModal.getElementsByTagName('input'));
            var focusableErrSelectField = first(errInModal === null || errInModal === void 0 ? void 0 : errInModal.getElementsByClassName('choices'));
            if (focusableErrInput && focusableErrSelectField === undefined) {
              focusableErrInput === null || focusableErrInput === void 0 || focusableErrInput.focus();
            } else {
              focusableErrSelectField === null || focusableErrSelectField === void 0 || focusableErrSelectField.focus();
            }
          }
          handleSubmit();
        }
      }))))));
    }
  });
}
EditAddressFields.propTypes = {
  addresses: PropTypes.array.isRequired,
  addressTypes: PropTypes.array.isRequired,
  deleteAddress: PropTypes.func.isRequired,
  styles: PropTypes.shape({
    inlineAddressContainer: PropTypes.object.isRequired
  }),
  updateOrCreateAddress: PropTypes.func.isRequired
};
EditAddressFields.defaultProps = {
  styles: {
    inlineAddressContainer: {
      borderBottom: '1px solid #EBECED',
      marginBottom: '20px',
      paddingBottom: '10px'
    }
  }
};
export default EditAddressFields;
//# sourceMappingURL=index.js.map